// Module
var code = "<template><compose class=\"page-brand-site column grow-xs-1 min-height-0\" view-model=\"../brand/dialogs/brand-site-dialog\"></compose></template>";
// Exports
module.exports = code;